/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewRankingItem
 */
export interface CRSFSecReviewRankingItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewRankingItem
     */
    month: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewRankingItem
     */
    rank: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewRankingItem
     */
    year: number;
}

/**
 * Check if a given object implements the CRSFSecReviewRankingItem interface.
 */
export function instanceOfCRSFSecReviewRankingItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "month" in value;
    isInstance = isInstance && "rank" in value;
    isInstance = isInstance && "year" in value;

    return isInstance;
}

export function CRSFSecReviewRankingItemFromJSON(json: any): CRSFSecReviewRankingItem {
    return CRSFSecReviewRankingItemFromJSONTyped(json, false);
}

export function CRSFSecReviewRankingItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewRankingItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'month': json['month'],
        'rank': json['rank'],
        'year': json['year'],
    };
}

export function CRSFSecReviewRankingItemToJSON(value?: CRSFSecReviewRankingItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'month': value.month,
        'rank': value.rank,
        'year': value.year,
    };
}

